<nav *ngIf='!isLoggedIn' class='navbar navbar-expand-lg py-2 show-login'>
  <button type='button' class='login' [disabled]='!(isConnectionLoaded() | async)' (click)='onLoginClick()'>
    Login
  </button>
</nav>

<nav *ngIf='isLoggedIn && (userService.userStorageObservable | async) && userService.hasProfile()' class='navbar navbar-expand-lg'>
  <a class='navbar-brand' (click)='onLogoSelected()'>
    <img src='assets/logo/altius_insights.svg' alt='Altius Insights logo' class='brand-logo brand-logo--insights' />
    <img *ngIf='userService.getLogoSrc()' [src]='userService.getLogoSrc()' alt='Company logo' class='brand-logo brand-logo--company' />
  </a>

  <div *ngIf='showDashboardSwitcher' class='dashboard-switcher me-3'>
    <button
      type='button'
      class='btn btn-outline-secondary btn-sm dashboard-switcher__toggle'
      (click)='isDashboardDropdownOpen = !isDashboardDropdownOpen'>
      {{ activeDashboardName }}
      <i class='fa ms-1' [ngClass]="isDashboardDropdownOpen ? 'fa-chevron-up' : 'fa-chevron-down'" aria-hidden='true'></i>
    </button>
    <ul *ngIf='isDashboardDropdownOpen' class='dashboard-switcher__menu'>
      <li
        *ngFor='let dashboard of otherDashboards'
        class='dashboard-switcher__item'
        (click)='onDashboardSelect(dashboard)'>
        {{ dashboard.name }}
      </li>
    </ul>
  </div>

  <app-profile-dropdown *ngIf='userService.hasProfile()'
    [isHoverDropdown]='true'
    [photoSrc]='userService.profilePic$ | async'
    [levelSrc]='userService.getMyLevelSrc()'
  ></app-profile-dropdown>
</nav>
